// Move to respective module after revamping to V3
export const ACCOUNT_NUMBER_MIN_LENGTH = 6;
export const ACCOUNT_NUMBER_MAX_LENGTH = 16;

export const HEADER_HEIGHT_OFFSET = '60px';
export const APP_CONTENT_MAX_WIDTH = '360px';

export const ALL_IMAGES = ['image/*'];
export const ALL_VIDEOS = ['video/*'];

export const CAR_REGISTRATION_NUMBER_REGEX =
    '^(AN|AP|AR|AS|BR|CG|CH|DN|DD|DL|GA|GJ|HR|HP|JK|JS|JH|KA|KL|LD|MP|MH|MN|ML|MZ|NL|OR|OD|PB|PY|PN|RJ|SK|TN|TS|TR|UA|UK|UP|WB)( *)( *|-)( *)([0-9]{1,2})( *)( *|-)( *)([a-zA-Z]{0,3})( *)( *|-)( *)([0-9]{1,4})$';

export const BH_CAR_REGISTRATION_NUMBER_REGEX =
    '^[2-3][0-9][Bb][Hh](([1-9]\\d\\d\\d)|(\\d[1-9]\\d\\d)|(\\d\\d[1-9]\\d)|(\\d\\d\\d[1-9]))[A-HJ-NP-Za-hj-np-z]{1,2}$';

export const CAR_ENUMS = ['PRIVATE_CAR', 'PCV', 'car'];

//todo:this needs to be fetched from dynamic config
export const registrationNumberRegex = [
    '^[A-Z][A-Z][0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$',
    '^[A-Z][A-Z][0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$',
    '^[A-Z][A-Z][A-Z][0-9][0-9][0-9][0-9]$',
    '^[A-Z][A-Z][0-9][0-9][A-Z][A-Z][A-Z][0-9][0-9][0-9][0-9]$',
    '^[A-Z][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$',
    '^[A-Z][A-Z][0-9][0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$',
    '^[A-Z][A-Z][0-9][0-9][0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$',
    '^[A-Z][A-Z][0-9][0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$',
    '^[A-Z][A-Z][0-9][0-9][A-Z][1-9][0-9][0-9][0-9][0-9]$',
    '^[A-Z][A-Z][0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9][0-9]$',
    '^[A-Z][A-Z][0-9][0-9][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$',
    '^(GJ|DL|BR)[0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$',
    '^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9]$',
    '^(GJ|DL|BR)[0-9][A-Z][A-Z][A-Z][0-9][0-9][0-9][0-9]$',
    '^(GJ|DL|BR)[0-9][0-9][0-9][0-9][0-9]$',
    '^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9][0-9]$',
    '^(GJ|DL|BR)[0-9][A-Z][A-Z][0-9][0-9][0-9][0-9][0-9]$',
    '^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$',
    '^(GJ|DL|BR)[0-9][A-Z][0-9][0-9][0-9][0-9][0-9][0-9]$',
    '^[0-9][0-9][A-Z][A-Z][0-9][0-9]$',
    '^[0-9][0-9][A-Z][A-Z][0-9][0-9][0-9]$',
    '^[0-9][0-9][A-Z][0-9][0-9][0-9][0-9]$',
    '^[0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9]$',
    '^[0-9][0-9][A-Z][A-Z][0-9][0-9][0-9][0-9][A-Z]$',
    '^[0-9][0-9][X][X][0-9][0-9][0-9][0-9][A-Z][A-Z]$',
];

export const AUTH_KEYS = {
    X_WORKSHOP_ID: 'x-workshop-id',
    X_AUTH_USER_ID: 'x-auth-user-id',
    X_USER_ID: 'x-user-id',
    ACKODRIVE_TOKENS: 'ackodrive_tokens',
    X_ENTITY: 'x-entity',
    X_ENTITY_ID: 'x-entity-id',
    X_SOURCE_ID: 'x-source-id',
    X_ORIGIN_ID: 'x-origin-id',
};

export const TRACKER_ID = 'trackerid';

export const EV = 'EV';
export const ELECTRIC = 'ELECTRIC';

export const PERIODIC_SERVICE = 'Periodic service';

export const TYPEFORM_LINK = 'https://acko.typeform.com/to/tK7cmK8a';

export const GARAGE_FRONTEND_SOURCE_ID = 'AUTO_GARAGE_FRONTEND';
export const AUTO_GARAGE_FRONTEND_15 = 'AUTO_GARAGE_FRONTEND_15';

export const AUTH_ENTITY_TYPE = {
    ORDER: 'ORDER',
    APPOINTMENT: 'APPOINTMENT',
};

export const ASSET_FALLBACK_IMAGE =
    'https://ackodrive-prod.ackoassets.com/_next_static/images/placeHolder-FallbackImage.png';

export const CAR_MAKES = {
    MARUTI: 'maruti',
    HYUNDAI: 'hyundai',
    TATA: 'tata',
    MAHINDRA: 'mahindra',
    TOYOTA: 'toyota',
    VOLKSWAGEN: 'volkswagen',
    SKODA: 'skoda',
    RENAULT: 'renault',
    NISSAN: 'nissan',
    FORD: 'ford',
    KIA: 'kia',
    CHEVROLET: 'chevrolet',
    HONDA: 'honda',
    FIAT: 'fiat',
};

export const COUPON_DEFAULT_DESCRIPTION = 'Car Services at ₹';
export const FREE_CAR_SPA = '+ FREE Car Spa';
